import { render, staticRenderFns } from "./NavNextTo.vue?vue&type=template&id=bb47dbda&scoped=true&"
import script from "./NavNextTo.vue?vue&type=script&lang=js&"
export * from "./NavNextTo.vue?vue&type=script&lang=js&"
import style0 from "./NavNextTo.vue?vue&type=style&index=0&id=bb47dbda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb47dbda",
  null
  
)

export default component.exports